import React from "react"
import { ClassBox } from "./ClassBox/ClassBox"

const LiveClassTile = ({ activities }) => {
  const classBoxArray = activities.length
    ? activities.map((el) => <ClassBox key={el.activity_id} {...el} />)
    : []
  return <React.Fragment>{classBoxArray}</React.Fragment>
}
export default LiveClassTile
